import { CultureInfo } from '../culture-info.model';
import { CultureInfoSr } from './sr';

/**
 * @ignore
 */
export const CultureInfoSrCyrl: CultureInfo = {
  name: 'sr-Cyrl',
  displayName: 'Serbian (Cyrillic)',
  iso3LanguageCode: 'srp',
  iso2LanguageCode: 'sr',
  ietfLanguageTag: 'sr-Cyrl',
  parent: CultureInfoSr
};
